import type { KeybindingOverrideMap } from "~/helpers/keybindingOverrides";

import { effectiveBindingsForAction, getKeyboardAction, type KeyboardActionId } from "~/keyboard/actionCatalog";

const hintBadgeBinding = (actionId: KeyboardActionId, overrides: KeybindingOverrideMap = {}): string | null => {
	const action = getKeyboardAction(actionId);
	if (!action) return null;
	const [binding] = effectiveBindingsForAction(action, overrides);
	return binding ?? null;
};

export default hintBadgeBinding;
